import { SpinTheWheelSvg } from './components/SpinTheWheelSvg'
import FallbackImage from '../media/imageFallback.svg'

export type SvgConfig = {
  headline?: string
}

export type SvgComponent = (props: SvgConfig) => React.ReactElement

export type SvgName = 'spin-the-wheel'

/**
 * When adding new SVGs to this registry, convert your SVG to JSX first.
 * SVG attributes need to be converted to their React/JSX equivalents:
 * - stroke-width becomes strokeWidth
 * - class becomes className
 * - etc.
 *
 * Recommended tools:
 * - https://svg2jsx.com
 * - https://react-svgr.com/playground
 */
const svgRegistry: Record<SvgName, SvgComponent> = {
  'spin-the-wheel': SpinTheWheelSvg,
  // Add other SVGs here
}

export const getSvg = (name?: string, config: SvgConfig = {}) => {
  if (!name || !(name in svgRegistry)) {
    return <img src={FallbackImage} alt="fallback" />
  }

  const Component = svgRegistry[name as SvgName]
  return Component(config)
}

export type SvgProps = {
  svgElementName: string
  svgHeadline: string
}

export function Svg({ svgElementName, svgHeadline }: SvgProps) {
  const svg = getSvg(svgElementName, { headline: svgHeadline })
  return svg
}
